<script>
import { isValidEmail } from '@/utils/validation';
import { iButton, iTextInput, showToast } from '@inscribe/signal';
import { encodeQueryParams } from '@/utils/queryParams';

export default {
  components: {
    iButton,
    iTextInput,
  },
  data() {
    return {
      email: '',
      loading: false,
      isPasswordReset: false,
      displayHint: false,
    };
  },
  computed: {
    isValidEmail() {
      return isValidEmail(this.email);
    },
    signInLink() {
      let baseUrl = '/auth/login';
      if (this.$route.query) {
        baseUrl = `${baseUrl}?${encodeQueryParams(this.$route.query)}`;
      }
      return baseUrl;
    },
  },
  methods: {
    requestPasswordReset() {
      this.displayHint = false;
      if (this.isValidEmail) {
        const data = new FormData();
        data.append('email', this.email);
        this.loading = true;
        this.$store
          .dispatch('requestPasswordReset', data)
          .then((response) => {
            this.loading = false;
            this.isPasswordReset = true;
          })
          .catch((error) => {
            showToast({
              title: 'There was a problem requesting a password reset link',
              text: error?.response?.data?.message || 'Please try again later',
              isError: true,
            });
          });
      } else {
        this.displayHint = true;
      }
    },
  },
};
</script>

<template>
  <div
    class="password-reset-request-screen auth-screen d-flex flex-column align-items-center justify-content-center i-gap-10"
  >
    <!-- title -->
    <div class="box d-flex flex-column align-items-center i-gap-1">
      <div class="title i-text-heading-3 i-text-neutral-120">
        {{ isPasswordReset ? 'Check your inbox!' : 'Reset password' }}
      </div>
      <div class="message i-text-body-1 i-text-neutral-110">
        {{
          isPasswordReset
            ? `A link to reset your password has been sent to
        ${email}`
            : ' We’ll send you instructions to reset'
        }}
      </div>
    </div>

    <div v-if="!isPasswordReset" class="form d-flex flex-column i-gap-10">
      <i-text-input
        :value="email"
        placeholder="Enter your email"
        label="Email address"
        name="email"
        type="email"
        :has-error="displayHint && !isValidEmail"
        :show-hint-text="displayHint && !isValidEmail"
        hint-text="A valid email is required"
        data-testid="password-reset-email"
        @input="email = $event"
        @on-input-enter="requestPasswordReset()"
      >
      </i-text-input>

      <!-- loading button -->
      <i-button
        text="Send Reset Instructions"
        type="primary"
        subtype="strong"
        size="lg"
        :loading="loading"
        data-testid="password-reset-submit-button"
        @button-click="requestPasswordReset"
      ></i-button>

      <!-- link standard login -->
      <div class="login-link d-flex justify-content-center">
        <router-link class="i-text-subheading-2" :to="signInLink">
          Back to Sign In
        </router-link>
      </div>
    </div>
  </div>
</template>
